import {
  LOAD_ALL_QUOTES,
  LOAD_ALL_QUOTES_FAILED,
  LOAD_ALL_QUOTES_CLIENT,
  SET_QUOTE_STATUS_BY_QUOTE_CLIENT_ID,
  LOAD_QUOTE_BY_ID,
  UPDATE_TOKEN_QUOTE_BY_USER_EMAIL_AND_PASSWORD,
  ADD_QUOTE,
  UPDATE_QUOTE,
  REMOVE_QUOTE_BY_ID,
  ARCHIVE_QUOTE_BY_ID,
  CLEAR_CURRENT_QUOTE, GET_HTML_PRE_VIEW_QUOTE, GET_HISTORY_QUOTE,
} from '../../actions/quotes';

export default function quotes(state = {}, action) {
  switch (action.type) {
    case LOAD_ALL_QUOTES:
      return Object.assign({}, state, action.payload);
    case LOAD_ALL_QUOTES_FAILED:
      return Object.assign({}, state, action.payload);
    case LOAD_ALL_QUOTES_CLIENT:
      return Object.assign({}, state, action.payload);
    case SET_QUOTE_STATUS_BY_QUOTE_CLIENT_ID:
      return Object.assign({}, state, action.payload);
    case LOAD_QUOTE_BY_ID:
      return Object.assign({}, state, action.payload);
    case GET_HTML_PRE_VIEW_QUOTE:
      return Object.assign({}, state, action.payload);
    case UPDATE_TOKEN_QUOTE_BY_USER_EMAIL_AND_PASSWORD:
      return Object.assign({}, state, action.payload);
    case ADD_QUOTE:
      return Object.assign({}, state, action.payload);
    case UPDATE_QUOTE:
      return Object.assign({}, state, action.payload);
    case GET_HISTORY_QUOTE:
      return Object.assign({}, state, action.payload);
    case REMOVE_QUOTE_BY_ID:
      for (let i = 0; i < state.list.length; i++) {
        if (state.list[i].id == action.payload.id) {
          state.list.splice(i, 1);
        }
      }
      return Object.assign({}, state, action.payload);
    case ARCHIVE_QUOTE_BY_ID:
      return Object.assign({}, state, action.payload);
    case CLEAR_CURRENT_QUOTE:
      delete state.quote;
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/quotes/index.js